import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { pageHead } from "@/lib/route-head";
const CityLanding = lazy(() => import("@/pages/CityLanding"));

const cityName = (slug: string) =>
  slug.split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

export const Route = createFileRoute("/cities/$citySlug")({
  head: ({ params }) => {
    const name = cityName(params.citySlug);
    return pageHead({
      path: `/cities/${params.citySlug}`,
      title: `Curated Social Dining in ${name} | Amorette`,
      description: `Amorette curated dining in ${name} — small tables, hand-selected restaurants, and real connection. See availability or join the waitlist.`,
    });
  },
  component: CityLanding,
});
